import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { InventoryDetail } from '@/types/inventory';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/**
 * Only the keys it carries change: kitchensink binds a plain-JSON PATCH over the stored row. A PUT would rewrite every
 * column, including `allocated`, which orders change while the page is open. `cost` is never null: channel_integrations
 * reads it into a non-nullable int, so a NULL cost stops the inventory and offer feeds of every subscription that reads
 * the row.
 */
export type InventoryDetailPatch = { quantity?: number; cost?: string };

export const patchInventoryDetail = async (
  scope: RequestScope,
  { id, data }: { id: number; data: InventoryDetailPatch },
  options: WriteRequestOptions
): Promise<EndpointResponse<InventoryDetail>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<InventoryDetail>>(`inventory_detail/${id}`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
